import { appClient } from 'api/apiClient';
import { buildPageQuery, type Paginated } from 'api/v1Helpers';
import { normalizeAnnouncement, type ApiAnnouncement, type Announcement, type CreateAnnouncementPayload } from 'types/announcementsV1';

export async function listAnnouncements(
    parishId: string,
    opts?: { page?: number; pageSize?: number; status?: string }
): Promise<Paginated<Announcement>> {
    const params = buildPageQuery(opts?.page ?? 1, opts?.pageSize ?? 20, {
        status: opts?.status,
    });
    const page = await appClient.get<Paginated<ApiAnnouncement>>(`parishes/${parishId}/announcements?${params.toString()}`);
    return {
        items: (page.items || []).map(normalizeAnnouncement),
        total: page.total ?? 0,
        page: page.page ?? opts?.page ?? 1,
        pageSize: page.pageSize ?? opts?.pageSize ?? 20,
    };
}

export async function getAnnouncement(parishId: string, id: string): Promise<Announcement> {
    const res = await appClient.get<ApiAnnouncement>(`parishes/${parishId}/announcements/${id}`);
    return normalizeAnnouncement(res);
}

export async function createAnnouncement(
    parishId: string,
    payload: CreateAnnouncementPayload,
    idempotencyKey?: string
): Promise<Announcement> {
    const headers = idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined;
    const res = await appClient.post<ApiAnnouncement>(`parishes/${parishId}/announcements`, payload, headers);
    return normalizeAnnouncement(res);
}

export async function deleteAnnouncement(parishId: string, id: string): Promise<void> {
    await appClient.delete(`parishes/${parishId}/announcements/${id}`);
}
